<template lang="pug">
div
  h1 隐私政策
  p
    | PandaFan保护和尊重您的隐私。本隐私政策（以下简称「本政策」）规定了我们在您访问我们的网站、使用我们的产品和服务（以下简称「服务」）或在您与我们进行业务往来时，如何收集和处理您的个人信息。
  p
    | 请仔细阅读本政策，了解我们如何处理和对待您的个人信息。
  p
    | 如本政策的中、英文版本存在差异，以英文版为准。
  h2
    | 我们收集哪些信息？
  p
    | PandaFan收集数据是为了使我们能够有效地运营服务，并为您提供最好的网站和服务体验。部分数据由您直接向我们提供：例如，当您注册使用我们的服务、订阅新闻、回复调查、通过我们的网站进行咨询、联系我们寻求支持，或作为潜在客户、供应商、供应商或顾问联系我们时，您将直接为我们提供信息。部分数据在您与我们的网站和服务的互动时由我们记录：例如，使用cookies等技术。在我们提供服务时，我们也会获取和处理相应的数据。
  details
    summary 了解更多
    p
      | 您可以选择是否同意我们收集数据。当您被要求提供个人数据时，您可以拒绝。但如果您拒绝给出我们服务所需的必要数据，您可能无法使用全部或部分服务。
    p
      | 我们收集的具体数据内容取决于您与PandaFan互动的背景、您的选择（包括您的隐私设置）以及您使用的服务。我们收集的数据可能包括以下内容。
    ul.list-disc
      li
        p
          strong 姓名和账单信息
          | . 我们可能会收集您的姓名、电子邮件地址、密码、住址、公司信息和其他类似的联络数据。
      li
        p
          strong 付款信息
          | . 当您在我们的网站上购物时，将直接通过一个安全的新窗口连接到我们的支付供应商（目前是Stripe），您提供的所有支付信息都将直接发送到支付供应商。我们无权访问这些信息。
      li
        p
          strong 设备和使用信息
          | . 我们可能会收集有关您的设备，以及您和您的设备如何与PandaFan以及我们的服务互动的数据。例如，我们可能会收集
        ul.list-disc
          li
            p
              em 使用数据
              | . 我们可能会收集有关您使用的功能和您购买的服务的数据。这也包括您在我们网站上的互动，以及您通过电子邮件与我们的互动的数据。
          li
            p
              em 设备、连接和配置数据
              | . 我们可能会收集有关您的设备和您用于连接到我们的服务的网络的数据。这可能包括IP地址、浏览器类型、操作系统和引用网址。
  h2
    | 我们
    b 不收集
    | 哪些信息？
  p
    | PandaFan只收集尽可能少的必要的数据来保证服务正常运作，除去您在使用服务时主动提供的，以及上述我们声明将会收集的数据外，我们承诺不会收集您通过本服务访问的目标IP、网址等浏览记录。
  h2
    | 我们使用您的信息做什么？
  p
    | 我们使用收集的数据来经营我们的业务，并向您提供服务。这包括使用数据来改善我们的服务，并使您的体验个性化。我们还可能使用这些数据与您进行沟通，其中包括通知您的账户、提供安全更新、提供有关服务的信息。我们也可能使用这些数据来管理您的电子邮件订阅、提高我们网站的相关性和安全性、回复用户的询问以及向您发送有关我们服务的重要信息。
  details
    summary 了解更多
    p
      strong 沟通。
      | 我们使用收集到的数据与您进行沟通，并使我们与您的沟通更加个性化。例如，我们可能会与您联系，通知您何时结束订阅、就您的帐户提供信息、让您知道何时有更新、提醒您有关您可使用的服务功能，或回复您的客服需求。
    p
      strong 提供和改善我们的服务。
      | 我们使用数据来提供和改进我们提供的服务，并执行基本的业务操作。包括运营服务、维护和改进服务的性能、开发新功能、进行分析和提供客户支持。此类用途的例子包括：
    ul.list-disc
      li
        p
          strong 提供服务
          |  我们使用数据来开展您与我们的交易，并向您提供服务。为提高您的工作效率以及更好地享受服务，在某些情况下，我们给出个性化的功能和建议，并根据我们掌握的有关您的数据自动调整您的体验。
      li
        p
          strong 技术支持
          |  我们使用数据来诊断产品问题，并提供其他客户关怀和支持服务。
      li
        p
          strong 改善服务
          |  我们使用数据来不断改进我们的网站和服务，包括系统管理、系统安全和增加新的功能或服务。
      li
        p
          strong 业务运营
          |  我们使用数据进行开发、总结和分析，以使我们能够运营、保护、做出正确的决策，并提升我们的业务表现。
      li
        p
          strong 发送事务性电子邮件
          |  我们可能会使用您的数据向您发送事务性邮件和其他重要通知邮件。
    p
      | 简单而言，
      | 一般情况下，我们使用数据来回复您对我们服务的问询和要求，创建和管理您的账户，向您提供您要求的信息以及数据资源。我们还将数据用于一般业务目的，包括（其中包括）改善客户服务、帮助我们改进服务的内容和功能、更好地了解用户需求、防止不法行为、执行我们的服务条款，以及整体性地管理我们的业务。

  h2
    | 我们如何保护您的信息？
  p
    | 当您输入、提交或访问您的个人信息时，我们采取各种安全措施来维护您的个人信息的安全。我们使用安全服务器，所有提供的敏感/信用信息将通过安全套接字层（SSL）技术传输，然后加密发送到我们的支付网关提供商的数据库，您的私人信息（如信用卡）将不会被存储在我们的服务器上。
  h2
    | 我们是否使用Cookies？
  p
    | 是的。Cookies是网站或其服务提供商通过您的网络浏览器（如果您允许的话）传输到您的计算机硬盘上的文件，使其系统能够识别您的浏览器并捕获和记住某些信息。您可以选择禁用Cookie，但如果您这样做，使用或访问我们网站某些部分可能会受到影响。
  h2
    | 我们是否会向外界透露任何信息？
  p
    | 仅在必要情况下，且经您的同意，我们才会分享您的个人数据。我们在以下情况下还会分享您的数据：与代表我们工作的供应商分享您的数据；当法律要求或响应法律程序时；保护客户权益；保护人身安全；维护我们服务的安全；以及为保护我们的权利或财产时。
  details
    summary 了解更多
    p
      | 仅在必要情况下，经您的同意，我们才会分享您的个人数据。我们还会与代表我们工作的供应商或代理人共享个人数据，以实现本政策所述的目的。例如，我们合作的提供云托管服务、异地备份和客户支持的公司可能需要访问个人数据以提供其功能。在这种情况下，我们要求这些公司必须遵守我们的数据隐私和安全要求，并且不得将他们从我们这里收到的个人数据用于任何其他目的。
    p
      | 我们可能会在企业交易中披露您的个人数据，如企业出售、合并、重组、解散或类似事件。
    p
      | 最后，当我们有充分的理由相信有必要这样做时，我们将访问、转移、披露和/或保存个人数据。
    ul.list-disc
      li 遵守适用法律或回应有效的法律程序、司法命令或传票。
      li 响应公共或政府当局的要求，包括出于国家安全或执法目的。
      li 保护我们的用户、客户或其他第三方的重要利益（包括，例如，防止垃圾邮件或欺诈信息，或帮助防止任何人的生命财产损失）。
      li 操作和维护本公司服务的安全，包括防止或阻止对本公司计算机系统或网络的攻击。
      li 保护PandaFan或第三方的权利、利益或财产。
      li 防止或调查与本服务有关的不法行为；或
      li 执行我们的服务条款。
    p 我们不会向第三方出售或交易您的个人信息。
  h2
    | 第三方链接
  p 
    | 偶尔，我们会在我们的网站上抑或是我们的服务来提供第三方产品或服务。如果您使用我们提供的链接访问第三方网站，这些网站的运营商可能会收集您的信息，并根据第三方网站独立的隐私政策使用您的数据。因此，我们对这些网站的内容和活动不承担任何责任。尽管如此，我们会努力确保我们网站的完整性，并欢迎您对此类第三方网站的任何反馈。
  h2
    | 我们在哪里存储和处理个人数据
  p
    | 为了提供我们的服务，PandaFan收集的个人数据可能会在荷兰，以及其他PandaFan或其关联公司、未来的子公司或服务提供商所在的国家和地区进行存储和处理。选择在这些地区存储数据的目的是为了提高工作效率、改善性能，并在发生故障或其他问题时保护数据。无论在哪里处理数据，我们都会采取措施，确保我们收集的数据是按照本政策和适用法律的要求进行处理的。

  h2
    | 数据保留
  p
    | 只要您继续使用本服务，在本公司拥有账户，或在实现本政策所述目的所需的时间内，本公司可以保留您的个人信息。您可以联系我们要求关闭您的账户，我们将应您的要求删除您的个人信息。

  p
    | 然而，我们可能会在适用法律允许或要求的情况下，出于法律、税收或监管原因，或出于正当合法的商业目的，在一段时间内保留您的个人信息。
  details
    summary 了解更多
    p 我们将在向您提供服务所需的时间内保留您的个人数据，或出于其他必要的目的，如：遵守和尽到我们的法律义务、解决争议和执行我们的协议。由于在提供的不同服务的背景下，我们对不同类型的数据的需求可能会有所不同，因此实际的保留期限可能会有很大的不同。
    p 提供服务和/或经营我们的业务需要保留多长时间的个人数据？这包括诸如维持和改善服务的性能、保持我们系统的安全以及维护适当的业务和财务记录等。这是确立大多数数据保留期的基线的整体规则。
  h2
    | 我们的隐私政策的变更
  p
    | 我们将在必要时更新本隐私声明，以回应客户的反馈、适应我们服务的变化。如果本声明发生重大变化，或者PandaFan对您的个人信息的使用方式发生变化，我们将在这些变化生效前在显著位置张贴通知或直接向您发送通知。我们建议且鼓励您定期查看本隐私声明，以了解PandaFan如何保护您的信息。
  h2
    | 如何联系我们
  p
    | 如果您有任何问题，请通过我们的
    a(href='/dashboard/support/') 支持页面联系我们
    | 。
</template>
